import {Buffer} from 'buffer';

const base64Encode = (obj: object): string =>  {
    const jsonString = JSON.stringify(obj);
    const bufferObj = Buffer.from(jsonString);

    return bufferObj.toString('base64')
}

const base64Decode = (base64Obj: string): object => {
    const decodedBufferObj = Buffer.from(base64Obj, 'base64');
    const decodedStringObj = decodedBufferObj.toString();

    return JSON.parse(JSON.parse(decodedStringObj))
}

export {base64Encode,base64Decode}